export default __webpack_public_path__ + "static/media/micro_bitcoin.c2f93df7.png";